// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3ZnJW","actionsCol":"EnrolledClinics_actionsCol__209Hf"};